import { render } from "./MergeWithMailForm.vue?vue&type=template&id=5518263b&scoped=true"
import script from "./MergeWithMailForm.vue?vue&type=script&lang=js"
export * from "./MergeWithMailForm.vue?vue&type=script&lang=js"

import "./MergeWithMailForm.vue?vue&type=style&index=0&id=5518263b&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5518263b"]])

export default __exports__